import { Component, OnInit } from "@angular/core";
import { BaseComponent, UserService, WindowService, CommunityService, environment } from "@mypxplat/xplat/core";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-account-notifications",
  templateUrl: "./notifications.component.html",
  standalone: false,
})
export class NotificationsComponent extends BaseComponent implements OnInit {
  public wantsEmail: any;
  public wantsProductEmail: boolean;
  public optoutEmail: boolean;
  public emmaiFrame: any;
  public saveButtonText: string;
  public saving: boolean = false;
  public resubscribeImgSrc: string;
  public env = environment;
  public email_settings: any;
  public fenderEmailSettings: {
    fender_news: boolean;
    fender_news_intl: boolean;
    fender_studio_news: boolean;
    presonus_news: boolean;
  };
  public communityPreferences: any = {
    all: true,
    mentions: true,
    direct_messages: true,
    post_replies: true,
    reply_replies: true,
    none: false,
  };
  protected bluecoreAction: string;

  constructor(
    public userService: UserService,
    private _translate: TranslateService,
    private _win: WindowService,
    public communityService: CommunityService,
    public appService: AppService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.email_settings = this.user.email_settings;
    this.fenderEmailSettings = this.user.fender_email_settings || {
      fender_news: false,
      fender_news_intl: false,
      fender_studio_news: false,
      presonus_news: false,
    };
    this.setupNotificationPrefs();
    this.saveButtonText = this._translate.instant("general.save");
  }

  saveIterablePreferences() {
    this.saveButtonText = this._translate.instant("general.saving_dots");
    if (!this.user.active_subscription && this.email_settings) this.email_settings.removeS1PlusMessageType = true;
    if (this.bluecoreAction && this.email_settings) this.email_settings.bluecoreSubscriptionEvent = this.bluecoreAction;
    let args = this.email_settings;
    args = this.fenderEmailSettings;
    this.userService.saveIterableSettings(args).subscribe((result: any) => {
      if (result.success) {
        this._win.setTimeout(() => {
          this.userService.getUserDetails(false).subscribe(() => {
            this.email_settings = this.user.email_settings;
            if (this.user.fender_email_settings) this.fenderEmailSettings = this.user.fender_email_settings;
            this.saveButtonText = this._translate.instant("general.saved");
            this._win.setTimeout(() => {
              this.saving = false;
              this.saveButtonText = this._translate.instant("general.save");
              this.bluecoreAction = null;
            }, 1000);
          });
        }, 6000);
      } else {
        this.saveButtonText = this._translate.instant("general.save");
        this.saving = false;
        alert(result.message || result.error);
      }
    });
  }

  setupNotificationPrefs() {
    this.wantsEmail = this.user.wantsEmail;
    this.wantsProductEmail = this.user.wantsProductEmail;
    this.optoutEmail = this.user.optoutEmail;
  }

  setOptOut(value) {
    this.optoutEmail = !this.optoutEmail;
    if (value) {
      this.resubscribeImgSrc = "http://e.presonus.com/public/?q=direct_add&fn=Public_DirectAddForm&id=aczejuwnafsxuggizrtlcfxejodybpd&email=" + this.user.email;
    } else {
      this.resubscribeImgSrc = undefined;
    }
  }

  saveNotificationPrefs() {
    let args = {
      wantsEmail: this.wantsEmail,
      wantsProductEmail: this.wantsProductEmail,
      optoutEmail: this.optoutEmail,
    };
    this.saveButtonText = this._translate.instant("general.saving_dots");
    this.userService.saveNotifications(args).subscribe((result: any) => {
      if (result.success) {
        this.userService.getUserDetails(false).subscribe(() => {
          if (result.optin_src) {
            window.open(result.optin_src);
          }
          this.saveButtonText = this._translate.instant("general.saved");
          this._win.setTimeout(() => {
            this.saving = false;
            this.saveButtonText = this._translate.instant("general.save");
          }, 1000);
        });
      } else {
        this.saveButtonText = this._translate.instant("general.save");
        this.saving = false;
        alert(result.message || result.error);
      }
    });
  }
}
